import TransparentButton from '@/trio-ui/TransparentButton';
import { InterviewQuestionType } from '@/types/api';
import DialogBox from '../DialogBox';
import InterviewQuestion from '../InterviewQuestion';

export type CustomQuestionType = Partial<
  InterviewQuestionType & {
    isEditing: boolean;
    draft: string;
    generateQuestionByAI?: string;
  }
>;

type PreScreeningQuestionsProps = {
  questions: CustomQuestionType[];
  canManageQuestions: boolean;
  onEditQuestion: (index: number) => void;
  onCancelEditingQuestion: (index: number) => void;
  onChangeQuestion: (index: number, event: any) => void;
  onAddNewInterviewQuestion: (index: number) => void;
  onConfirmQuestionDelete: (id: string) => void;
  onAddNewQuestions: (event: any) => void;
  idToDelete?: string;
  setIdToDelete: (id: string) => void;
  onDeleteInterviewQuestion: () => void;
};

export default function PreScreeningQuestions({
  questions,
  canManageQuestions,
  onEditQuestion,
  onCancelEditingQuestion,
  onChangeQuestion,
  onAddNewInterviewQuestion,
  onConfirmQuestionDelete,
  onAddNewQuestions,
  idToDelete,
  setIdToDelete,
  onDeleteInterviewQuestion,
}: PreScreeningQuestionsProps): JSX.Element {
  return (
    <div>
      {questions.map((question, index) => {
        return (
          <InterviewQuestion
            key={question.id || `new-question-${index}`}
            id={question.id ?? ''}
            questionTitle={`Question ${index + 1}`}
            isEditing={!!question?.isEditing}
            canEdit={canManageQuestions}
            questionText={question?.questionText ?? ''}
            answer={question.answer?.attachmentUrl ?? question.answer?.textAnswer}
            onEdit={() => onEditQuestion(index)}
            onCancelEdit={() => onCancelEditingQuestion(index)}
            onChangeQuestion={(e) => onChangeQuestion(e, index)}
            onSave={() => onAddNewInterviewQuestion(index)}
            onDelete={() => onConfirmQuestionDelete(question?.id as string)}
          />
        );
      })}

      {canManageQuestions && (
        <TransparentButton onClick={onAddNewQuestions} isBlueButton>
          + New Question
        </TransparentButton>
      )}

      <DialogBox
        isOpen={!!idToDelete}
        onCancelHandler={() => setIdToDelete('')}
        onConfirmHandler={() => onDeleteInterviewQuestion()}
      />
    </div>
  );
}
